import BackButton from "../GoBack/GoBack";
import "./Profile.css";
import { useAuthStudent } from "../../../context/StudentLoginContext/StudentAuthContext";
import Avatar from "react-avatar";
import { useEffect, useState } from "react";
import { ChangePasswordStudent } from "./ChangePassword/ChangePasswordStudent";
import { StudentMapMenu } from "../Map/MapMenu/MapMenu";
import { Link, useOutletContext } from "react-router-dom";
import { useTenantAuth } from "../../../../context/TeanantAuthProvider";

export const StudentAdminProfile = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const [studentProfileData, setStudentProfileData] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const { userType } = useOutletContext();
  const { currentUser } = useTenantAuth();

  const { student, fetchWithAuthStudent } = useAuthStudent();
  useEffect(() => {
    const fetchQuestData = async () => {
      if (!student || !student.token) {
        return;
      }

      try {
        const response = await fetchWithAuthStudent(
          `${apiUrl}/student/profile/${student?.student?.id}`,
          {
            method: "GET",
          }
        );

        if (!response.ok) {
          throw new Error("Failed to fetch users");
        }

        const data = await response.json();

        setStudentProfileData(data);
      } catch (error) {}
    };
    fetchQuestData();
  }, [apiUrl, student, fetchWithAuthStudent]);

  return (
    <div className="StudentAdminBody StudentBodyMrgn">
      <img
        className="circleTopBar"
        src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/common/TopbarCirlcleBlue.png"
        alt=""
      />
      <div className="container-fluid">
        <div className="teacher-bodycontent mb-4">
          <section>
            <div className="mb-4">
              <BackButton />
            </div>

            <div className="MainContainer">
              {/* Left */}
              <div
                className="LeftContainer text-center"
                style={{
                  backgroundImage: `url('https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/profile/Leftsidebg.png')`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                }}
              >
                <div className="ProfileData text-center">
                  <div className="ProfileImage mb-3">
                    {userType === "school-student" ? (
                      <Avatar
                        name={currentUser?.name}
                        size="100"
                        round="10px"
                        color="#008EF4"
                      />
                    ) : (
                      <Avatar
                        name={studentProfileData?.data?.name}
                        size="100"
                        round="10px"
                        color="#008EF4"
                      />
                    )}
                  </div>
                  <div className="NameIdDiv">
                    <p className="KidName mb-1">
                      {userType === "school-student"
                        ? currentUser?.name
                        : studentProfileData?.data?.name}
                    </p>
                    <p className="KidId">
                      {userType === "school-student"
                        ? currentUser?.username
                        : studentProfileData?.data?.username}
                    </p>
                  </div>
                </div>

                <div className="QuestQuizCards">
                  <div className="QuestCard">
                    <div className="pt-4">
                      <i className="bi bi-file-earmark-text-fill document-icon"></i>
                    </div>
                    <p className="QuestsNumber mb-1">
                      {studentProfileData?.data?.total_quest}
                    </p>
                    <p className="QuestsText">Total Quests</p>
                  </div>

                  <div className="QuizzesCard">
                    <div className="pt-4">
                      <i className="bi bi-file-earmark-text-fill document-icon"></i>
                    </div>
                    <p className="QuestsNumber mb-1">
                      {studentProfileData?.data?.completed_quest}
                    </p>
                    <p className="QuizzesText">Completed Quizzes</p>
                  </div>
                </div>
              </div>

              {/* Right */}
              <div className="RightContainer">
                <div className="PersonalInformation">
                  <p className="PersonalInformationText">
                    Personal Information
                  </p>
                  <form className="mt-4">
                    {Number(studentProfileData?.data?.age) >= 13 && (
                      <div className="mb-3 row">
                        <label className="col-form-label FieldName">
                          Email
                        </label>
                        <div className="col-12">
                          <input
                            type="email"
                            disabled
                            className="form-control"
                            value={
                              student?.student?.email || "student@gmail.com"
                            }
                          />
                        </div>
                      </div>
                    )}

                    <div className="mb-3 row">
                      <label className="col-form-label FieldName">Name</label>
                      <div className="col-12">
                        <input
                          type="name"
                          disabled
                          className="form-control"
                          value={userType === "school-student" ? currentUser?.name : studentProfileData?.data?.name}
                        />
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="col-form-label FieldName">Age</label>
                      <div className="col-12">
                        <input
                          type="text"
                          disabled
                          className="form-control"
                          value={userType === "school-student" ? currentUser?.age : studentProfileData?.data?.age}
                        />
                      </div>
                    </div>
                  </form>
                  {Number(studentProfileData?.data?.age) >= 13 && (
                    <button
                      className="kidRegistrSubmtBtn mb-2 mt-4"
                      onClick={() => setShowModal(true)}
                    >
                      Change Password
                    </button>
                  )}
                  {showModal && (
                    <ChangePasswordStudent
                      showModal={showModal} // Pass the modal visibility
                      handleQuestClose={() => setShowModal(false)} // Pass the close function
                    />
                  )}
                </div>

                <Link to="/student/admin/trophy">
                  <div
                    className="TrophyRoom"
                    style={{
                      backgroundImage: `url('https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/profile/Rightsidebg.png')`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      backgroundRepeat: "no-repeat",
                    }}
                  >
                    <div>
                      <p className="TrophyRoomText text-white">Award Room</p>
                      <p className="TrophyCompleteText text-white">
                        Complete the quest to win an award
                      </p>
                    </div>
                    <div
                      className="flex-grow-1 d-flex align-items-center justify-content-center position-relative mb-4"
                      style={{ minHeight: "180px" }}
                    >
                      {/* Trophy image */}
                      <img
                        src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/profile/Trophy.png"
                        alt="Trophy"
                        className="mx-auto"
                        style={{ zIndex: 2 }}
                      />

                      {/* Decorative icons */}
                      <img
                        src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/profile/1.png"
                        alt=""
                        className="position-absolute"
                        style={{ top: "-10%", left: "15%", width: "20px" }}
                      />
                      <img
                        src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/profile/2.png"
                        alt=""
                        className="position-absolute"
                        style={{ top: "15%", right: "0%", width: "20px" }}
                      />
                      <img
                        src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/profile/3.png"
                        alt=""
                        className="position-absolute"
                        style={{
                          bottom: "50%",
                          left: "0%",
                          width: "20px",
                        }}
                      />
                      <img
                        src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/profile/5.png"
                        alt=""
                        className="position-absolute"
                        style={{
                          bottom: "15%",
                          left: "10%",
                          width: "20px",
                        }}
                      />
                      <img
                        src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/profile/4.png"
                        alt=""
                        className="position-absolute"
                        style={{
                          bottom: "10%",
                          right: "20%",
                          width: "20px",
                        }}
                      />
                    </div>
                  </div>
                </Link>
              </div>
            </div>
          </section>

          {/* <StudentFooter /> */}
          <StudentMapMenu />
        </div>

        {/* Side Design Images */}
        <div style={{ position: "absolute" }}>
          <img
            src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/common/LeftSideDesign.png"
            alt="left"
            className="position-fixed "
            style={{
              left: 0,
              top: "10vh",
              height: "90vh",
              zIndex: -1,
            }}
          />
          <img
            src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/common/RightSideDesign.png"
            alt="right"
            className="position-fixed  "
            style={{
              right: 0,
              top: "20vh",
              height: "70vh",
              zIndex: -1,
            }}
          />
        </div>
      </div>
    </div>
  );
};
